import { gql } from "@apollo/client";

export const GET_RECLAMOS_BY_PROFESIONAL_ID = gql`
  query GetGestionReclamoByProfesionalId($idProfesional: Int!) {
  gestionReclamoByProfesionalId(idProfesional: $idProfesional) {
    idGestionReclamo
    descripcion
    fechaOcurrencia
    fechaRegistro
    idEstadoReclamo
    idEstadoReclamoNavigation{
        descripcion
    }
    idUsuarioCreadorNavigation{
        nombre
        apellido
    }
  }
}`;